import styled from 'styled-components';

const MainContentContainer = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  height: calc(100vh - 100px); // 100px is the height of the header
`;

export default MainContentContainer;
